<template>
    <Link
        class="inline-flex items-center px-4 py-2.5 border border-transparent rounded-md font-semibold text-xs uppercase tracking-widest focus:outline-none transition ease-in-out duration-150 justify-center"
        :class="colorClass"
        :disabled="disabled"
    >
        <slot />
    </Link>
</template>


<script>

import { Link } from '@inertiajs/inertia-vue3';
export default {
    components: {
        Link,
    },
    props: {
        color: {
            type: String,
            default: 'gray', // gray, red, blue, green, yellow
        },
        light: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        }
    },
    computed: {
        colorClass() {
            const {color, light, disabled} = this;
            return [
                light ? 'text-black' : 'text-white',
                disabled ? 'cursor-not-allowed' : 'cursor-pointer',
                color === 'blue' ?
                    disabled ?
                        light ? 'bg-blue-100' : 'bg-blue-300'
                        : light ? 'bg-blue-400 hover:bg-blue-500 active:bg-blue-600 focus:border-blue-600 focus:shadow-outline-blue'
                            : 'bg-blue-600 hover:bg-blue-700 active:bg-blue-800 focus:border-blue-800 focus:shadow-outline-blue'
                    : color === 'red' ?
                        disabled ?
                            light ? 'bg-red-100' : 'bg-red-300'
                            : light ? 'bg-red-400 hover:bg-red-500 active:bg-red-600 focus:border-red-600 focus:shadow-outline-red'
                                : 'bg-red-600 hover:bg-red-700 active:bg-red-800 focus:border-red-800 focus:shadow-outline-red'
                        : color === 'green' ?
                            disabled ?
                                light ? 'bg-green-100' : 'bg-green-300'
                                : light ? 'bg-green-400 hover:bg-green-500 active:bg-green-600 focus:border-green-600 focus:shadow-outline-green'
                                    : 'bg-green-600 hover:bg-green-700 active:bg-green-800 focus:border-green-800 focus:shadow-outline-green'
                            : color === 'yellow' ?
                                disabled ?
                                    light ? 'bg-yellow-100' : 'bg-yellow-300'
                                    : light ? 'bg-yellow-400 hover:bg-yellow-500 active:bg-yellow-600 focus:border-yellow-600 focus:shadow-outline-yellow'
                                        : 'bg-yellow-600 hover:bg-yellow-700 active:bg-yellow-800 focus:border-yellow-800 focus:shadow-outline-yellow'
                                : disabled ?
                                    light ? 'bg-gray-100' : 'bg-gray-300'
                                    : light ? 'bg-gray-400 hover:bg-gray-500 active:bg-gray-600 focus:border-gray-600 focus:shadow-outline-gray'
                                        : 'bg-gray-600 hover:bg-gray-700 active:bg-gray-800 focus:border-gray-800 focus:shadow-outline-gray',
            ]
        },
    },
}
</script>
